import { FETCH_PRIVILEGE, FETCH_PRIVILEGES, FETCH_ROLE, FETCH_ROLES, FETCH_USER, FETCH_USERS, TASK_DATA } from "../Dispatchers";

const initialState = {
    users: [],
    user: {},
    roles: [],
    role: {},
    privileges: [],
    privilege: {},
    masters:[]
}
export function AdminReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_USERS:
            return {
                ...state, users: action.payload
            }
        case TASK_DATA:
            return {
                ...state, masters: action.payload
            }
        case FETCH_USER:
            return {
                ...state, user: action.payload
            }
        case FETCH_ROLES:
            return {
                ...state, roles: action.payload
            }
        case FETCH_ROLE:
            return {
                ...state, role: action.payload
            }
        case FETCH_PRIVILEGES:
            return {
                ...state, privileges: action.payload
            }
        case FETCH_PRIVILEGE:
            return {
                ...state, privilege: action.payload
            }
        default:
            break;
    }
    return state;
}